import {
  Alert,
  AlertDescription,
  AlertIcon,
  AlertTitle,
} from '@chakra-ui/react';
import { type UsePDFInstance } from '@react-pdf/renderer';
import Loading from '@ui/components/Loading';
import { PDFViewer } from '@ui/components/PDFViewer';

export function PDFDisplay({
  quoteId,
  pdf,
}: {
  quoteId: string;
  pdf: UsePDFInstance;
}) {
  if (pdf.loading) {
    return <Loading />;
  }

  if (pdf.error || !pdf.url) {
    return (
      <Alert status="error">
        <AlertIcon />
        <AlertTitle>Whoops!</AlertTitle>
        <AlertDescription>PDF failed to render.</AlertDescription>
      </Alert>
    );
  }

  return <PDFViewer title={`Quote ${quoteId}`} pdfUrl={pdf.url} />;
}
